import { useTrEnumNamespace as e } from "@maat/store-i18n";
//#region src/useTrHostActionType.ts
var t = () => e("hostActionType");
//#endregion
export { t as useTrHostActionType };
